import { useParams } from 'react-router-dom';

import { Zone } from 'types';
import { User } from 'types/api/users.type';

import { useAppSelector } from 'redux/hooks';

import { usersDataService } from 'services/users.service';

import { useUsersContext } from 'contexts/UsersContext';

import { EditForm } from 'sections/EditForm';
import { SectionType } from 'sections/TabWrap';

import { Card } from 'components/Card';
import { Table } from 'components/Table';

import { useColumns } from './columns.hooks';
import { Checkboxes } from './components/Checkboxes';
import { useFormData } from './useFormData.hooks';

const SPECIAL_ZONES = ['*I', '*E', '*T'];

const useZone = () => {
  const zones = useAppSelector((state) => state.constants.zones);
  const { id } = useParams();

  const { user, userSet, form, onSubmit } = useUsersContext();

  const zonesCode = user?.zone.map((item) => item.code);
  const zonesFiltered = zones.filter((item: Zone) => {
    if (SPECIAL_ZONES.includes(item.code)) {
      return false;
    }
    if (zonesCode && zonesCode.includes(item.code)) {
      return false;
    }
    return true;
  });

  const formData = useFormData(zonesFiltered);

  const tableData = user?.zone
    .map((item) => ({
      zone: item.code,
      id: item.code,
    }))
    .filter((item) => item.zone);

  const deleteZone = (zoneCode: string, currentUser?: User) => {
    if (currentUser) {
      const zonesDeleted = currentUser?.zone.filter((item) => item.code !== zoneCode);

      const userData = { ...user, zone: zonesDeleted };

      if (id) {
        usersDataService.putUser(id, userData).then((res) => {
          if (userSet) {
            userSet(res.data);
          }
        });
      }
    }
  };

  const columns = useColumns(deleteZone, user);

  const sections: SectionType[] = [
    {
      id: 1,
      content: (
        <Card>
          <EditForm
            hasButtons
            control={form?.control}
            register={form?.register}
            data={formData}
            onSubmit={onSubmit}
            isDirty={form?.formState?.isDirty}
            hideUndo
            submitBtnLabel="+ add new zone"
          >
            <Checkboxes zones={user?.zone} control={form?.control} />
          </EditForm>
        </Card>
      ),
    },
    {
      id: 2,
      content: (
        <Table
          hasSort
          initialSorting={[
            {
              id: 'zone',
              desc: false,
            },
          ]}
          columns={columns}
          data={tableData || []}
        />
      ),
    },
  ];

  return {
    sections,
  };
};

export { useZone };
